<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg
   viewBox="0 0 96.734802 39.899601"
   version="1.1"
   xml:space="preserve"
   id="svg45"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
<path
   fill="none" stroke="#979595" stroke-width="4.167" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="2"
   d="M 2.0834999,37.8161 V 2.0834999 H 48.3674 V 37.8161 h 46.2839"
   id="path51" /></svg>
